module.exports = __webpack_public_path__ + "media/images/projet-lire-2c239aee5b5df8ebb4a57eff1e4a33bc.png";